export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'hotel',
    name: '酒店预订',
    description: '探索永利皇宫极致奢华客房与套房，享受宫殿级住宿体验',
    icon: 'ri-hotel-line',
    imageSeq: 'category-hotel-01',
  },
  {
    slug: 'dining',
    name: '餐厅推荐',
    description: '品味米其林星级美馔，开启环球美食之旅',
    icon: 'ri-restaurant-line',
    imageSeq: 'category-dining-01',
  },
  {
    slug: 'entertainment',
    name: '娱乐体验',
    description: '感受世界级娱乐表演与休闲设施，尽享欢乐时光',
    icon: 'ri-movie-line',
    imageSeq: 'category-entertainment-01',
  },
  {
    slug: 'shopping',
    name: '购物指南',
    description: '畅游顶级品牌旗舰店，体验奢华购物之旅',
    icon: 'ri-shopping-bag-line',
    imageSeq: 'category-shopping-01',
  },
  {
    slug: 'travel',
    name: '旅游攻略',
    description: '获取澳门深度游攻略，规划完美度假行程',
    icon: 'ri-compass-line',
    imageSeq: 'category-travel-01',
  },
];